import React from "react";
import { Link } from "react-router-dom";
import { Home, TrendingUp, Landmark, DollarSign, ArrowRight } from "lucide-react";
import { SectionHeading } from "./ui";
import { Reveal } from "./useReveal";

const PATHS = [
  {
    icon: Home, tag: "Buy", title: "Find Your Dream Home",
    desc: "Smart home search, personalized recommendations, and expert negotiation, from first-time buyers to luxury estates.",
    cta: "Start Searching", href: "/buy",
  },
  {
    icon: DollarSign, tag: "Sell", title: "Maximize Your Return",
    desc: "Strategic pricing, professional marketing, and strong local exposure to help you sell for top dollar.",
    cta: "Get a Valuation", href: "/sell",
  },
  {
    icon: TrendingUp, tag: "Investors", title: "Build Your Portfolio",
    desc: "Data-driven insights and local expertise to identify opportunities across Greater Los Angeles.",
    cta: "Search Homes", href: "/idx",
  },
  {
    icon: Landmark, tag: "Finance", title: "Unlock Your Buying Power",
    desc: "FHA, Conventional, VA, and Non-QM loans through a network of wholesale lenders, and we shop rates for you.",
    cta: "Explore Options", href: "/financing",
  },
];

export const PathSection = () => (
  <section className="py-16 lg:py-24 bg-[#F5F5F5]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="Full-Service Brokerage"
          title="Your Path to Buying, Selling &amp; Financing"
          subtitle="One team for every side of your move, with real estate and mortgage guidance in one place."
        />
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PATHS.map((p, i) => (
          <Reveal key={p.tag} delay={i * 70}>
            <Link
              to={p.href}
              data-testid={`path-card-${p.tag.toLowerCase()}`}
              className="lift group h-full flex flex-col bg-white border border-[#E5E5E5] rounded-[20px] p-8 hover:border-[#C9A961]"
            >
              <div className="w-12 h-12 rounded-xl bg-[#254369] flex items-center justify-center mb-5">
                <p.icon className="text-[#C9A961]" size={22} />
              </div>
              <p className="text-[#C9A961] font-heading font-bold uppercase tracking-[0.16em] text-xs">{p.tag}</p>
              <h3 className="font-heading font-bold text-lg text-[#2D2D37] mt-1">{p.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#2D2D37]/65 flex-1">{p.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#254369] group-hover:text-[#C9A961] transition-colors">
                {p.cta} <ArrowRight size={15} />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
